export default `
  mutation deleteAvatarFile($key: String!) {
    deleteAvatarFile(key: $key) {
      key
      deleted
    }
  }
`
